import * as XLSX from "xlsx";

export const generateExcel = (data) => {
  const workbook = XLSX.utils.book_new();
  const worksheetData = [];
  const merges = [];

  worksheetData.push([
    "Service Provider Name",
    "Service Provider URL",
    "Request ID",
    "Address",
    "Country",
    "Services Provided",
    "Service Countries",
    "Primary Name",
    "Primary Email",
    "Primary Contact",
    "Secondary Name",
    "Secondary Email",
    "Secondary Contact",
    "Created On",
    "Modified On",
  ]);

  if (!Array.isArray(data) || data.length === 0) {
    console.error("Data is either not an array or is empty");
    return;
  }

  const groupedData = data.reduce((acc, curr) => {
    const key = `${curr.serviceProviderName}-${curr.requestId}`;
    if (!acc[key]) {
      acc[key] = { ...curr, services: [] };
    }
    acc[key].services.push(curr);
    return acc;
  }, {});

  Object.values(groupedData).forEach((provider) => {
    const services = provider.services;
    const firstService = services[0];
    const baseRow = [
      firstService.serviceProviderName,
      firstService.serviceProviderURL,
      firstService.requestId,
      firstService.address,
      firstService.country,
      "",
      "",
      firstService.primaryName,
      firstService.primaryEmail,
      firstService.primaryContact,
      firstService.secondaryName,
      firstService.secondaryEmail,
      firstService.secondaryContact,
      firstService.createdOn.replace(/^"(.*)"$/, "$1").replace(/\.\d{6}$/, ""),
      firstService.modifiedOn.replace(/^"(.*)"$/, "$1").replace(/\.\d{6}$/, ""),
    ];

    worksheetData.push(baseRow);
    services.forEach((service, index) => {
      if (index > 0) {
        worksheetData.push([
          "",
          "",
          "",
          "",
          "",
          service.servicesProvided,
          service.serviceCountries,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ]);
      } else {
        worksheetData[worksheetData.length - 1][5] = service.servicesProvided;
        worksheetData[worksheetData.length - 1][6] = service.serviceCountries;
      }
    });

    const lastRow = worksheetData.length - 1;
    merges.push({
      s: { r: lastRow - services.length + 1, c: 0 },
      e: { r: lastRow, c: 0 },
    });

    for (let col = 1; col <= 4; col++) {
      merges.push({
        s: { r: lastRow - services.length + 1, c: col },
        e: { r: lastRow, c: col },
      });
    }

    for (let col = 7; col <= 14; col++) {
      merges.push({
        s: { r: lastRow - services.length + 1, c: col },
        e: { r: lastRow, c: col },
      });
    }
  });

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  if (!worksheet) {
    return;
  }
  worksheet["!merges"] = merges;

  merges.forEach((merge) => {
    const cell = worksheet[XLSX.utils.encode_cell(merge.s)];
    if (cell) {
      cell.s = {
        alignment: { horizontal: "center", vertical: "center" },
      };
    }
  });

  XLSX.utils.book_append_sheet(workbook, worksheet, "Service Providers");
  XLSX.writeFile(workbook, "GCTOSP_service_provider.xlsx");
};
